module.exports = __webpack_public_path__ + "static/media/语音识别.fe012c47.png";